{
  "header": {
    "eyebrow": "Payments",
    "title": "QR payment",
    "description": "QR-code charging sessions and payment stickers.",
    "action": "Open EVinity dashboard"
  },
  "sessions": {
    "title": "QR sessions",
    "count": "{{count}} session",
    "count_other": "{{count}} sessions",
    "searchPlaceholder": "Search by station, location or transaction",
    "searchAria": "Search QR sessions",
    "openExternal": "Open in CPMS",
    "perKwh": "{{value}}/kWh",
    "columns": {
      "location": "Location",
      "status": "Status",
      "started": "Started",
      "amount": "Amount",
      "price": "Price",
      "actions": "Actions"
    },
    "status": {
      "initiated": "Initiated",
      "checkedOut": "Checked out",
      "charging": "Charging",
      "completed": "Completed",
      "cancelled": "Cancelled"
    },
    "empty": {
      "title": "No QR sessions",
      "description": "No QR sessions match the current search."
    },
    "error": {
      "title": "couldn't load QR sessions",
      "description": "Something went wrong loading the QR sessions. Please try again."
    }
  },
  "stickers": {
    "title": "QR stickers",
    "count": "{{count}} linked",
    "searchPlaceholder": "Search by sticker, station or location",
    "searchAria": "Search QR stickers",
    "add": "Add sticker",
    "idLabel": "ID {{id}}",
    "columns": {
      "sticker": "Sticker",
      "location": "Charging station",
      "actions": "Actions"
    },
    "actions": {
      "edit": "Edit link",
      "share": "Copy QR link",
      "download": "Download QR code",
      "delete": "Remove link"
    },
    "empty": {
      "title": "No linked stickers",
      "description": "No stickers match the current search. Add one to link it to a charging station."
    },
    "error": {
      "title": "couldn't load QR stickers",
      "description": "Something went wrong loading the QR stickers. Please try again."
    },
    "dialog": {
      "addTitle": "Link QR sticker",
      "editTitle": "Edit QR sticker",
      "description": "Connect a sticker to the charging station it should start a session for.",
      "stickerLabel": "Sticker",
      "stickerPlaceholder": "Select a sticker…",
      "stickerOption": "Sticker {{id}}",
      "stationLabel": "Charging station",
      "stationPlaceholder": "Select a charging station…",
      "cancel": "Cancel",
      "save": "Save"
    },
    "deleteDialog": {
      "title": "Remove sticker link",
      "description": "Unlink sticker {{id}} from its charging station? The sticker returns to the pool.",
      "confirm": "Remove link"
    },
    "toasts": {
      "linked": "Sticker {{id}} linked.",
      "updated": "Sticker {{id}} updated.",
      "unlinked": "Sticker {{id}} unlinked.",
      "copied": "Link copied: {{url}}",
      "saveFailed": "Could not save the sticker. Please try again.",
      "deleteFailed": "Could not remove the link. Please try again.",
      "copyFailed": "Could not copy the link.",
      "qrFailed": "Could not generate the QR code."
    }
  }
}
